import React from 'react';
import { useInView } from 'react-intersection-observer';
import { Calendar, User, ArrowRight } from 'lucide-react';
export function Blog() {
  const {
    ref,
    inView
  } = useInView({
    threshold: 0.1,
    triggerOnce: true
  });
  const blogPosts = [{
    id: 1,
    title: 'Finding Your Identity in Christ',
    excerpt: 'Discover how to embrace your true identity as a daughter of God and break free from worldly labels.',
    category: 'Her Identity',
    author: 'She Wins Ministry',
    date: 'June 15, 2023',
    image: 'https://images.unsplash.com/photo-1504805572947-34fad45aed93?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80'
  }, {
    id: 2,
    title: 'Building a Strong Prayer Life',
    excerpt: 'Learn practical steps to develop a consistent and powerful prayer routine that transforms your spiritual journey.',
    category: 'Her Prayer Life',
    author: 'She Wins Ministry',
    date: 'July 2, 2023',
    image: 'https://images.unsplash.com/photo-1507099985932-87a4520ed1d5?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80'
  }, {
    id: 3,
    title: 'Overcoming Fear and Anxiety',
    excerpt: "Biblical strategies for conquering fear and finding peace in God's promises during life's challenges.",
    category: 'Her Emotion',
    author: 'She Wins Ministry',
    date: 'July 28, 2023',
    image: 'https://images.unsplash.com/photo-1544027993-37dbfe43562a?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80'
  }];
  return <section id="blog" className="py-20 bg-white" data-id="element-29">
      <div className="container mx-auto px-4" data-id="element-30">
        <div className="text-center mb-12" data-id="element-31">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-32">
            Blog & Resources
          </h2>
          <div className="w-24 h-1 bg-pink-600 mx-auto" data-id="element-33"></div>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-34">
            Explore our collection of articles, devotionals, and resources
            designed to help you grow in every area of your life.
          </p>
        </div>
        <div ref={ref} className={`grid md:grid-cols-3 gap-8 transition-all duration-1000 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-35">
          {blogPosts.map(post => <BlogCard key={post.id} post={post} data-id="element-36" />)}
        </div>
        <div className="text-center mt-12" data-id="element-37">
          <a href="#" className="inline-flex items-center text-pink-600 hover:text-pink-700 font-medium transition-colors duration-200" data-id="element-38">
            View All Blog Posts
            <ArrowRight size={18} className="ml-2" data-id="element-39" />
          </a>
        </div>
      </div>
    </section>;
}
function BlogCard({
  post
}) {
  return <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300" data-id="element-40">
      <div className="h-48 overflow-hidden" data-id="element-41">
        <img src={post.image} alt={post.title} className="w-full h-full object-cover transition-transform duration-300 hover:scale-105" data-id="element-42" />
      </div>
      <div className="p-6" data-id="element-43">
        <div className="flex items-center mb-2" data-id="element-44">
          <span className="text-xs font-medium bg-pink-100 text-pink-600 px-2 py-1 rounded-full" data-id="element-45">
            {post.category}
          </span>
        </div>
        <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-46">{post.title}</h3>
        <p className="text-gray-600 mb-4" data-id="element-47">{post.excerpt}</p>
        <div className="flex items-center justify-between text-sm text-gray-500" data-id="element-48">
          <div className="flex items-center" data-id="element-49">
            <User size={14} className="mr-1" data-id="element-50" />
            <span data-id="element-51">{post.author}</span>
          </div>
          <div className="flex items-center" data-id="element-52">
            <Calendar size={14} className="mr-1" data-id="element-53" />
            <span data-id="element-54">{post.date}</span>
          </div>
        </div>
        <div className="mt-4 pt-4 border-t border-gray-100" data-id="element-55">
          <a href="#" className="text-pink-600 hover:text-pink-700 font-medium inline-flex items-center transition-colors duration-200" data-id="element-56">
            Read More
            <ArrowRight size={16} className="ml-1" data-id="element-57" />
          </a>
        </div>
      </div>
    </div>;
}